import { render, staticRenderFns } from "./BOM.vue?vue&type=template&id=c0c4010a&"
import script from "./BOM.vue?vue&type=script&lang=js&"
export * from "./BOM.vue?vue&type=script&lang=js&"
import style0 from "./BOM.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports